import { render, staticRenderFns } from "./recommend_view.vue?vue&type=template&id=9bd9f7d4&scoped=true&"
import script from "./recommend_view.vue?vue&type=script&lang=js&"
export * from "./recommend_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd9f7d4",
  null
  
)

export default component.exports